export default __webpack_public_path__ + "static/media/logo.78cbb3a0.png";